import { IconButton } from '@mui/material';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useSnackbar } from 'notistack';
import * as React from 'react';

function SnackbarCloseButton({ sbkey }) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(sbkey)}>
      <span style={{marginRight: "3px", color:"#ffffff"}}>
        <FontAwesomeIcon icon={faClose} />
    </span>
    </IconButton>
  );
}

export default SnackbarCloseButton;